import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateThyroid from "./SelectDateThyroid.jsx";
import { useTranslation } from '../../../../language';

export default function BloodThyroidWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_thyr')}
      specify={t('page_sp_thyroid_health')}

      >

      {/* Main Page Content */}

       <SelectDateThyroid />


    </PageProtectedLayout>

  );
}
